import React, { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getCategories } from "../../services/productService";

const FALLBACK_CATEGORY_IMAGE = "/kuku-assets/images/category sweet.png";

const slugifyCategory = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const CategorySection = () => {
  const refs = useRef([]);
  const containerRef = useRef(null);
  const { data: categories = [] } = useQuery({
    queryKey: ["homepage-categories"],
    queryFn: getCategories,
  });

  const visibleCategories = categories.slice(0, 6);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else if (entry.boundingClientRect.top > 0) {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    refs.current.forEach((element) => element && observer.observe(element));

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [visibleCategories.length]);

  return (
    <section className="hp-category hp-section">
      <div className="max-w-[1320px] mx-auto px-4 hp-reveal" ref={containerRef}>
        <div className="hp-category-header flex justify-between items-center mb-6 flex-wrap gap-3">
          <h2 className="hp-category-heading text-2xl font-bold">Find Your Favorites</h2>
          <Link to="/categories" className="hp-cat-btn">
            View all Products
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-center">
          {visibleCategories.map((category, index) => {
            const categorySlug = category?.slug || slugifyCategory(category?.category_name || category?.category_id);

            return (
              <div
                key={category.category_id}
                className="hp-reveal"
                ref={(element) => {
                  refs.current[index] = element;
                }}
              >
                <Link to={`/categories/${categorySlug}`} className="block">
                  <img
                    src={category.category_image || FALLBACK_CATEGORY_IMAGE}
                    alt={category.category_name}
                    className="w-full rounded-xl"
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_CATEGORY_IMAGE;
                    }}
                  />
                  <span className="diff-btn mt-3 inline-block text-sm">
                    {category.category_name}
                  </span>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;